import { ProductionComponentInstanceBuildLog } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getBuildLogsForProductionComponentInstances(
  productionComponentInstanceGuids: readonly string[],
): Promise<readonly ProductionComponentInstanceBuildLog[]> {
  return DesignService.post(`public/productionComponentInstanceBuildLogs/getBuildLogsForProductionComponentInstances`, {
    data: { productionComponentInstanceGuids },
  });
}

export function getByStationGuid(
  stationGuid: string,
  startDateInclusive?: Date,
  endDateInclusive?: Date,
): Promise<readonly ProductionComponentInstanceBuildLog[]> {
  const params = new URLSearchParams();
  if (startDateInclusive) params.append('startDateInclusive', startDateInclusive.toISOString());
  if (endDateInclusive) params.append('endDateInclusive', endDateInclusive.toISOString());
  return DesignService.get(`public/productionComponentInstanceBuildLogs/byStationGuid/${stationGuid}`, { params });
}

export function setStartProduction(
  productionComponentInstanceGuid: string,
  stationGuid: string,
  startProduction: Date,
  enableOverwrite: boolean,
): Promise<void> {
  return DesignService.post('public/productionComponentInstanceBuildLogs/setStartProduction', {
    data: { productionComponentInstanceGuid, stationGuid, startProduction, enableOverwrite },
  });
}

export function setEndProduction(
  productionComponentInstanceGuid: string,
  stationGuid: string,
  endProduction: Date,
  enableOverwrite: boolean,
): Promise<void> {
  return DesignService.post('public/productionComponentInstanceBuildLogs/setEndProduction', {
    data: { productionComponentInstanceGuid, stationGuid, endProduction, enableOverwrite },
  });
}
